//

/**
 * Takes text and return sulugified version
 * @param {String} slug
 * @returns {String} formatted slug string
 */
function getSlug(slug = '') {
  if (!slug || slug === '') return ''
  return slug
    .toLowerCase()
    .replace(/ /g, '-') // replace spaces with hyphens
    .replace(/[^\w-]+/g, '') // remove special characters
    .replace(/--/g, '-') // remove double '--' created by removing special character only words
    .replace(/^-|-$/g, '') // remove leading and trailing hyphens
}

function isExternal(url, currentURL) {
  try {
    const CURRENT_URL = new URL(currentURL)
    const URLObject = new URL(url)
    return URLObject.host != CURRENT_URL.host
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (err) {
    return false
  }
}

/**
 * Replace domain name in the given asset URL to the appropriate
 * domain name for the respective asset types
 *
 * @param {string} url - The original asset URL
 * @returns {string} The modified asset URL
 */
const rewriteAssetUrl = (url) => {
  if (process.env.STORYBOOK_ENV) {
    return url
  }

  if (typeof url !== 'string' || !url) return ''

  const rewrittenUrl = url
    .replace('https://images.ctfassets.net', `/assets/images`)
    .replace('https://assets.ctfassets.net', `/assets/files`)
    .replace('//images.ctfassets.net', `/assets/images`)
    .replace('//assets.ctfassets.net', `/assets/files`)
  return rewrittenUrl
}

export { getSlug, isExternal, rewriteAssetUrl }
